export const isLowboyTimesheetValid = (lowboyTimesheet) => {
    if (
        !lowboyTimesheet ||
        !lowboyTimesheet.lowboyTimesheetContracts ||
        !lowboyTimesheet.lowboyTimesheetContracts.length
    ) {
        return false;
    }

    return lowboyTimesheet.lowboyTimesheetContracts.every((ltc) =>
        isLowboyTimesheetContractValid(ltc)
    );
};

export const isLowboyTimesheetContractValid = (lowboyTimesheetContract) =>
    lowboyTimesheetContract &&
    !isNaN(lowboyTimesheetContract.hoursSpent) &&
    lowboyTimesheetContract.hoursSpent &&
    lowboyTimesheetContract.hoursSpent > 0;

export const hasAnyNotes = (lowboyTimesheet) =>
    lowboyTimesheet &&
    (lowboyTimesheet.notes ||
        lowboyTimesheet.adjustmentNotes ||
        lowboyTimesheet.lowboyTimesheetContracts.some(
            (ltc) =>
                ltc.notes ||
                ltc.adjustmentNotes ||
                ltc.lowboyTimesheetDetails.some(
                    (ltd) => ltd.notes || ltd.adjustmentNotes
                )
        ));
